import {
	dateFormats,
	DateObject,
	useIntl,
	type UserBasicRequirement,
	type UserUKselfCategorisationRequirementConfig,
	type UserUKselfCategorisationUserProvidedValues
} from '@capsicum/common';
import { BaseTextInput } from '@capsicum/common-web';
import { type ChangeEvent, useEffect, useState } from 'react';
import styled from 'styled-components';

type UkSelfCategorisationRestrictedInvestorProps = {
	onUserInformationFormChange: (payload: UserUKselfCategorisationUserProvidedValues) => void;
	requirement: UserBasicRequirement;
};

export const UserInformationForm = ({
	onUserInformationFormChange,
	requirement
}: UkSelfCategorisationRestrictedInvestorProps) => {
	const { $t } = useIntl();

	const requirementConfig = requirement.config as UserUKselfCategorisationRequirementConfig;

	const [firstName, setFirstName] = useState<string>(requirementConfig.prefill?.user?.firstName || '');
	const [lastName, setLastName] = useState<string>(requirementConfig.prefill?.user?.lastName || '');

	const dateOfToday = dateFormats.format(new DateObject(), 'DD/MM/YYYY');

	const handleFirstNameChange = (value: string) => {
		setFirstName(value);
		const newRestrictedFormValues: UserUKselfCategorisationUserProvidedValues = {
			firstName: value,
			lastName
		};

		onUserInformationFormChange(newRestrictedFormValues);
	};

	const handleLastNameChange = (value: string) => {
		setLastName(value);
		const newRestrictedFormValues: UserUKselfCategorisationUserProvidedValues = {
			firstName,
			lastName: value
		};

		onUserInformationFormChange(newRestrictedFormValues);
	};

	useEffect(() => {
		const initialRestrictedFormValues: UserUKselfCategorisationUserProvidedValues = {
			firstName,
			lastName
		};

		onUserInformationFormChange(initialRestrictedFormValues);
	}, []);

	return (
		<S.UserInformation>
			<BaseTextInput
				disabled={!!requirementConfig.prefill?.user?.firstName}
				label={$t('global.firstName')}
				testID="investor-firstname-input"
				value={firstName}
				onChange={(event: ChangeEvent<HTMLInputElement>) => handleFirstNameChange(event.target.value)}
			/>
			<BaseTextInput
				disabled={!!requirementConfig.prefill?.user?.lastName}
				label={$t('global.lastName')}
				testID="investor-lastname-input"
				value={lastName}
				onChange={(event: ChangeEvent<HTMLInputElement>) => handleLastNameChange(event.target.value)}
			/>
			<BaseTextInput
				disabled
				label={$t('global.date')}
				testID="investor-date-of-today-input"
				value={dateOfToday}
			/>
		</S.UserInformation>
	);
};

namespace S {
	export const UserInformation = styled.div`
		margin: ${({ theme }) => `${theme.spacings.small} 0 0`};
		display: flex;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.xxsmall};
	`;
}
